import { createSlice } from "@reduxjs/toolkit";

export const standAloneSlice = createSlice({
  name: "standalone",
  initialState: {
    feedbacks: {
      feedbackData: [],
    },
  },
  reducers: {
    setStandaloneFeedbacks: (state, action) => {
      // Replace entire list with payload array
      state.feedbacks.feedbackData = Array.isArray(action.payload) ? action.payload : [];
    },
    addStandaloneFeedback: (state, action) => {
      // state.feedbacks.feedbackData.filter(feedback => feedback._id !== action.payload._id).
      state.feedbacks.feedbackData = state.feedbacks.feedbackData.some(fb => fb._id === action.payload._id)
        ? state.feedbacks.feedbackData.map(fb => fb._id === action.payload._id ? action.payload : fb)
        : [...state.feedbacks.feedbackData, action.payload];
      // state.feedbacks.feedbackData = [...state.feedbacks.feedbackData, action.payload];
    },
    removeStandaloneFeedbackAtTime: (state, action) => {
      const timeSec = Number(action.payload?.timeSec) || 0;
      const tol = Number(action.payload?.tol);
      const TOL = Number.isFinite(tol) ? Math.max(0, tol) : 0.75; // default 0.75s
      state.feedbacks.feedbackData = state.feedbacks.feedbackData.filter(fb => {
        const t = Number(fb?.timeRange?.startTime);
        if (!Number.isFinite(t)) return true;
        return Math.abs(t - timeSec) > TOL;
      });
    },

  }
})

export const { setStandaloneFeedbacks, addStandaloneFeedback, removeStandaloneFeedbackAtTime } = standAloneSlice.actions

export default standAloneSlice.reducer;
